import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';
import { homePathForRole, DEFAULT_HOME } from '@/routing/portalHome';
import { DashboardPage } from './DashboardPage';

/**
 * The /dashboard route. #350: an insurer is sent to the insurer dashboard
 * instead of being shown the broker dashboard (whose widgets read broker data
 * an insurer does not have). Every other role renders DashboardPage exactly as
 * before.
 */
export function DashboardEntry() {
  const { user } = useAuthStore();
  const home = homePathForRole(user?.role);
  if (home !== DEFAULT_HOME) {
    return <Navigate to={home} replace />;
  }
  return <DashboardPage />;
}
